<form
  class="flex flex-1 flex-col"
  #addBucketForm="ngForm"
  (ngSubmit)="addBucketFormSubmit(addBucketForm)"
  autocomplete="off"
>
  <div class="flex flex-col gap-6">
    <app-ui-field label="Group" [inputId]="'add-bucket-category'">
      <select
        id="add-bucket-category"
        appUiInput
        class="add-bucket-id"
        [(ngModel)]="bucket.groupId"
        name="groupId"
        required
      >
        @for (category of categorySelect(); track category.id) {
          <option [ngValue]="category.id">
            {{ category.name }}
          </option>
        }
      </select>
    </app-ui-field>

    <app-ui-field class="add-bucket-name" label="Budget name" [inputId]="'add-bucket-name'">
      <input
        id="add-bucket-name"
        appUiInput
        name="name"
        type="text"
        [(ngModel)]="bucket.name"
        maxlength="24"
        required
      />
    </app-ui-field>

    <app-bucket-type-selector
      [type]="selectedType()"
      name="type"
      (typeChange)="onTypeChange($event)"
    />

    <app-ui-field class="add-bucket-amount" [label]="amountLabel()" [inputId]="'add-bucket-amount'">
      <app-ui-currency-input
        inputId="add-bucket-amount"
        name="amount"
        required
        [(ngModel)]="bucket.amount"
      />
    </app-ui-field>

    @if (showsGoal()) {
      <app-ui-field class="add-bucket-goal" [label]="goalLabel()" [inputId]="'add-bucket-goal'">
        <app-ui-currency-input
          inputId="add-bucket-goal"
          name="fundGoal"
          [(ngModel)]="bucket.fund.goal"
        />
      </app-ui-field>
    }
  </div>

  <app-drawer-footer>
    <span class="flex-1"></span>
    <button appUiButton tone="primary" type="submit">Add budget</button>
  </app-drawer-footer>
</form>
